import React from 'react'
import { Button } from '@mui/material'
import {
  EmptyStateContainer,
  Title,
  Text,
  BackgroundPlaceholders,
  BackgroundColumn,
  BackgroundCard,
} from './EmptyState.styled'
/* eslint-disable */
type EmptyStateProps = {
  onAddSnapshot?: () => void
}

// Create an array of specific heights for better visual representation
const getBackgroundCardHeights = () => [
  180,
  320,
  250,
  400,
  280, // First column
  220,
  350,
  420,
  200,
  300, // Second column
  280,
  380,
  190,
  450,
  240, // Third column
]

export const EmptyState = ({ onAddSnapshot }: EmptyStateProps) => {
  const heights = getBackgroundCardHeights()

  return (
    <EmptyStateContainer>
      <BackgroundPlaceholders>
        {/* Left column */}
        <BackgroundColumn>
          {heights.slice(0, 5).map((height, i) => (
            <BackgroundCard
              key={`left-card-${height}-${i}`}
              style={{ height: `${height}px` }}
            />
          ))}
        </BackgroundColumn>

        {/* Middle column */}
        <BackgroundColumn>
          {heights.slice(5, 10).map((height, i) => (
            <BackgroundCard
              key={`middle-card-${height}-${i}`}
              style={{ height: `${height}px` }}
            />
          ))}
        </BackgroundColumn>

        {/* Right column */}
        <BackgroundColumn>
          {heights.slice(10, 15).map((height, i) => (
            <BackgroundCard
              key={`right-card-${height}-${i}`}
              style={{ height: `${height}px` }}
            />
          ))}
        </BackgroundColumn>
      </BackgroundPlaceholders>

      <div>
        <Title>No Snapshots to Show</Title>
        <Text>
          Check out our snapshot features! They&apos;re a great way to capture
          moments and insights while keeping everyone in the loop.
        </Text>
      </div>
      <Button
        variant='outlined'
        onClick={onAddSnapshot}
        sx={{
          margin: 0,
          borderRadius: '20px',
          padding: '6px 24px',
          textTransform: 'none',
          fontWeight: 500,
          backgroundColor: 'white',
        }}
      >
        Add Snapshot
      </Button>
    </EmptyStateContainer>
  )
}
